import React from "react";

import { withStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Colors from "../../constants/Colors";

const styles = {
  accent: {
    marginRight: 5,
    fontWeight: 700,
    fontSize: "1.5rem"
  },

  circle: {
    width: 200,
    height: 200,
    borderRadius: 100,
    webkitBoxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    mozBoxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    boxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.main
  },
  rightBox: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 10,
    // height: 200,
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  catchPhrase: {
    color: Colors.text,
    marginLeft: 20,
    marginRight: 20,
    marginTop: 10,
    marginBottom: 10,
    fontSize: "1.25rem",
    // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    // lineHeight: 1.6,
    letterSpacing: "0.0075em"
  },
  statDiv: {
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex",
    flexDirection: "row"
  },
  round: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 15,
    padding: 10,
    borderRadius: "50%",
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8"

    // webkitBoxShadow: `0px 0px 15px 2px ${Colors.pink}`,
    // mozBoxShadow: `0px 0px 15px 2px ${Colors.pink}`,
    // boxShadow: `0px 0px 15px 2px ${Colors.pink}`
  }
};

const IconStatRow = ({ classes, color, children, text, stat }) => {
  return (
    <div className={classes.statDiv}>
      <div
        className={classes.round}
        style={{
          backgroundColor: color
          //   webkitBoxShadow: `0px 0px 15px 2px ${color}`,
          //   mozBoxShadow: `0px 0px 15px 2px ${color}`,
          //   boxShadow: `0px 0px 15px 2px ${color}`
        }}
      >
        {children}
      </div>
      <Paper className={classes.rightBox}>
        <p className={classes.catchPhrase}>
          <b className={classes.accent} style={{ color }}>
            {stat}
          </b>{" "}
          {text}
        </p>
      </Paper>
    </div>
  );
};

export default withStyles(styles)(IconStatRow);
